import { lighten, modularScale, transparentize, darken, mix, parseToRgb, normalize } from 'polished';
import React from 'react';
import { css } from 'emotion';
export { injectGlobal, keyframes, cx } from 'emotion';
import emotionStyled from 'react-emotion';
import { withTheme, channel, contextTypes } from 'emotion-theming';
export { ThemeProvider } from 'emotion-theming';
import PropTypes from 'prop-types';
import FocusLock from 'react-focus-lock';
import Transition from 'react-transition-group/Transition';
export { default as Transition } from 'react-transition-group/Transition';
import ReactDOM from 'react-dom';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var withTheme$1 = function withTheme$$1(Component) {
  var WithThemeComponent = withTheme(Component); // eslint-disable-next-line react/prefer-stateless-function

  var SafeWithTheme =
  /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose(SafeWithTheme, _React$Component);

    function SafeWithTheme() {
      return _React$Component.apply(this, arguments) || this;
    }

    var _proto = SafeWithTheme.prototype;

    _proto.render = function render() {
      if (!this.context[channel]) return React.createElement(Component, this.props);
      return React.createElement(WithThemeComponent, this.props);
    };

    return SafeWithTheme;
  }(React.Component);

  SafeWithTheme.contextTypes = contextTypes;
  return SafeWithTheme;
};

var isInterpolation = function isInterpolation(func) {
  if (typeof func !== 'function') return false; // eslint-disable-next-line no-underscore-dangle

  if (func.__emotion_styles) return false;
  return true;
};

var css$1 = function css$$1() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (args.some(function (arg) {
    return isInterpolation(arg);
  })) {
    return function (props) {
      if (!props) {
        throw new Error('Wrong usage of `css` function');
      }

      var transform = function transform(arg) {
        if (isInterpolation(arg)) {
          return transform(arg(props));
        }

        if (Array.isArray(arg)) {
          return arg.map(transform);
        }

        return arg;
      };

      var transformedArgs = transform(args);
      return css.apply(void 0, transformedArgs);
    };
  }

  return css.apply(void 0, args);
};

function patchStyledComponent(StyledComponent) {
  var withComponent = StyledComponent.withComponent;

  StyledComponent.withComponent = function (component, options) {
    // eslint-disable-next-line no-underscore-dangle
    var BaseComponent = StyledComponent.__emotion_base;
    return patchStyledComponent(Object.assign(withComponent(function (props) {
      return React.createElement(BaseComponent, _extends({
        as: component
      }, props));
    }, options), StyledComponent));
  };

  return StyledComponent;
}

function wrapCreateStyledComponent(createStyledComponent) {
  var wrappedCreateStyledComponent = function wrappedCreateStyledComponent() {
    var StyledComponent = createStyledComponent.apply(void 0, arguments);
    return patchStyledComponent(StyledComponent);
  };

  return wrappedCreateStyledComponent;
}

function wrapStyled(styled) {
  return function (component, options) {
    return wrapCreateStyledComponent(styled(component, options));
  };
}

var styled =
/*#__PURE__*/
wrapStyled(emotionStyled);

var DEFAULT_BREAKPOINTS = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200
};
var getBreakpoints = function getBreakpoints(props) {
  return props && props.theme && props.theme.breakpoints || DEFAULT_BREAKPOINTS;
};
var getBreakpointsEntries = function getBreakpointsEntries(props) {
  var breakpoints = getBreakpoints(props);
  var entries = Object.keys(breakpoints).reduce(function (entries, key) {
    return [].concat(entries, [[key, breakpoints[key]]]);
  }, []);
  return entries.sort(function (a, b) {
    return a[1] > b[1];
  });
};
var getNextBreakpoint = function getNextBreakpoint(name, props) {
  var entries = getBreakpointsEntries(props);
  var index = entries.findIndex(function (_ref) {
    var key = _ref[0];
    return key === name;
  });
  return index < entries.length - 1 ? entries[index + 1][0] : null;
};
var getPreviousBreakpoint = function getPreviousBreakpoint(name, props) {
  var entries = getBreakpointsEntries(props);
  var index = entries.findIndex(function (_ref2) {
    var key = _ref2[0];
    return key === name;
  });
  return index >= 1 ? entries[index - 1][0] : null;
};
/**
 * Minimum breakpoint width.
 * Null for the smallest breakpoint.
 */

var getBreakpointMin = function getBreakpointMin(name, props) {
  var breakpoints = getBreakpoints(props);
  var breakPoint = breakpoints[name];
  return breakPoint !== 0 ? breakPoint : null;
};
/**
 * Maximum breakpoint width. Null for the largest (last) breakpoint.
 * The maximum value is calculated as the minimum of the next one less 0.02px
 * to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.
 * See https://www.w3.org/TR/mediaqueries-4/#mq-min-max
 * Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.
 * See https://bugs.webkit.org/show_bug.cgi?id=178261
 */

var getBreakpointMax = function getBreakpointMax(name, props) {
  var next = getNextBreakpoint(name, props);
  return next ? getBreakpointMin(next, props) - 0.02 : null;
};
var mediaMinWidth = function mediaMinWidth(value) {
  return "@media (min-width: " + value + "px)";
};
var mediaMaxWidth = function mediaMaxWidth(value) {
  return "@media (max-width: " + value + "px)";
};
var mediaBetweenWidth = function mediaBetweenWidth(min, max) {
  return "@media (min-width: " + min + "px) and (max-width: " + max + "px)";
};
var up = function up(name, code) {
  return function (props) {
    var value = getBreakpointMin(name, props);
    if (value === null) return code;
    return (
      /*#__PURE__*/
      css$1(mediaMinWidth(value), "{", code, ";}")
    );
  };
};
var down = function down(name, code) {
  return function (props) {
    var next = getNextBreakpoint(name, props);
    var previous = getPreviousBreakpoint(name, props);
    var value = getBreakpointMax(previous, props);
    if (next === null) return code;
    return (
      /*#__PURE__*/
      css$1(mediaMaxWidth(value), "{", code, ";}")
    );
  };
};
var between = function between(lower, upper, code) {
  return function (props) {
    var min = getBreakpointMin(lower, props);
    var max = getBreakpointMax(upper, props);
    var upperPrevious = getPreviousBreakpoint(upper, props);
    var previousMax = getBreakpointMax(upperPrevious, props);

    if (min !== null && max !== null) {
      return (
        /*#__PURE__*/
        css$1(mediaBetweenWidth(min, previousMax), "{", code, ";}")
      );
    }

    if (max === null) return up(lower, code)(props);
    if (min === null) return down(upper, code)(props);
    return null;
  };
};

var is = function is(n) {
  return n !== undefined && n !== null;
};
var num = function num(n) {
  return typeof n === 'number' && !Number.isNaN(n);
};
var string = function string(n) {
  return typeof n === 'string' && n !== '';
};
var obj = function obj(n) {
  return typeof n === 'object' && n !== null;
};
var func = function func(n) {
  return typeof n === 'function';
};
var identity = function identity(n) {
  return n;
};
var negative = function negative(n) {
  return n < 0;
};
var get = function get(obj) {
  for (var _len = arguments.length, paths = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    paths[_key - 1] = arguments[_key];
  }

  return paths.join('.').split('.').reduce(function (a, b) {
    return a && is(a[b]) ? a[b] : undefined;
  }, obj);
};
var cascade = function cascade(fn) {
  if (!func(fn)) return fn;

  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  var next = fn.apply(void 0, args);
  return cascade.apply(void 0, [next].concat(args));
};
var merge = function merge(a, b) {
  return Object.assign({}, a, b, Object.keys(b || {}).reduce(function (all, key) {
    var _Object$assign;

    return Object.assign(all, (_Object$assign = {}, _Object$assign[key] = obj(a[key]) ? merge(a[key], b[key]) : b[key], _Object$assign));
  }, {}));
};
var omit = function omit(obj, fields) {
  var shallowCopy = _objectSpread({}, obj);

  for (var i = 0; i < fields.length; i += 1) {
    var key = fields[i];
    delete shallowCopy[key];
  }

  return shallowCopy;
};

var lazyTh = function lazyTh(name) {
  return function (props) {
    return cascade(function (p) {
      return get(p.theme, name);
    }, props);
  };
};
var th = function th(name, transform) {
  return function (props) {
    var result = lazyTh(name)(props);

    if (!is(result)) {
      throw new Error("\"" + name + "\" not found in theme");
    }

    return transform ? transform(result) : result;
  };
};
var mixin = function mixin(name) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return function (props) {
    return props.theme[name](props).apply(void 0, args);
  };
};
var prop = function prop(name, themeFallback) {
  return function (props) {
    return props[name] === undefined ? th(themeFallback)(props) : props[name];
  };
};
var calc = function calc(value, fn) {
  var _String$match = String(value).match(/([\d.]+)\s*(.*)/),
      num$$1 = _String$match[1],
      unit = _String$match[2];

  return "" + fn(Number(num$$1)) + (unit || 'px');
};
var unit = function unit(_unit) {
  return function (value) {
    return num(value) ? "" + value + _unit : value;
  };
};
var px =
/*#__PURE__*/
unit('px');

var styleFromValue = function styleFromValue(_ref) {
  var cssProperty = _ref.cssProperty,
      value = _ref.value,
      transform = _ref.transform,
      variantsKey = _ref.variants,
      props = _ref.props;

  if (variantsKey && is(value)) {
    // Try to extract from theme
    var variants = lazyTh(variantsKey)(props);

    if (variants) {
      var valueFromVariants = cascade(variants[value], props);

      if (is(valueFromVariants)) {
        value = valueFromVariants;
      }
    }
  }

  if (string(value) || num(value)) {
    var _ref2;

    return _ref2 = {}, _ref2[cssProperty] = transform(value), _ref2;
  }

  return null;
};

var stylePropType =
/*#__PURE__*/
PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object]);
function style(_ref3) {
  var _fn$propTypes;

  var prop = _ref3.prop,
      cssProperty = _ref3.cssProperty,
      _ref3$transform = _ref3.transform,
      transform = _ref3$transform === void 0 ? identity : _ref3$transform,
      variants = _ref3.variants;

  var fn = function fn(props) {
    var value = props[prop];
    if (!is(value)) return null;
    cssProperty = cssProperty || prop;
    var style = styleFromValue({
      value: value,
      cssProperty: cssProperty,
      transform: transform,
      variants: variants,
      props: props
    });
    if (style) return style;

    if (obj(value)) {
      return Object.keys(value).map(function (breakpoint) {
        var _ref4;

        var style = styleFromValue({
          cssProperty: cssProperty,
          value: value[breakpoint],
          transform: transform,
          variants: variants,
          props: props
        });
        if (!style) return null;
        var breakpointValue = getBreakpointMin(breakpoint, props);
        if (breakpointValue === null) return style;
        return _ref4 = {}, _ref4[mediaMinWidth(breakpointValue)] = style, _ref4;
      }).reduce(merge, {});
    }

    return null;
  };

  fn.propTypes = (_fn$propTypes = {}, _fn$propTypes[prop] = stylePropType, _fn$propTypes);
  fn.meta = {
    props: [prop]
  };
  return fn;
}
var composeStyles = function composeStyles() {
  for (var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    funcs[_key2] = arguments[_key2];
  }

  var fn = function fn(props) {
    return funcs.map(function (fn) {
      return fn(props);
    }).filter(Boolean).reduce(merge, {});
  };

  fn.propTypes = funcs.map(function (fn) {
    return fn.propTypes;
  }).reduce(merge, {});
  return fn;
};

/* eslint-disable no-unused-vars */

var fontFamily = '-apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif'; // Colors

var white = '#fff';
var gray100 = '#f8f9fa';
var gray200 = '#e9ecef';
var gray300 = '#dee2e6';
var gray400 = '#ced4da';
var gray500 = '#adb5bd';
var gray600 = '#6c757d';
var gray700 = '#495057';
var gray800 = '#343a40';
var gray900 = '#212529';
var black = '#000';
var blue = '#007bff';
var indigo = '#6610f2';
var purple = '#6f42c1';
var pink = '#e83e8c';
var red = '#dc3545';
var brick = '#bd4932';
var orange = '#fd7e14';
var yellow = '#ffc107';
var green = '#28a745';
var teal = '#20c997';
var cyan = '#17a2b8';
var primary =
/*#__PURE__*/
th('brick');
var secondary =
/*#__PURE__*/
th('gray600');
var success =
/*#__PURE__*/
th('green');
var info =
/*#__PURE__*/
th('cyan');
var warning =
/*#__PURE__*/
th('yellow');
var danger =
/*#__PURE__*/
th('red');
var light =
/*#__PURE__*/
th('gray100');
var dark =
/*#__PURE__*/
th('gray800');
var primaryLight =
/*#__PURE__*/
th('primary', function (c) {
  return lighten(0.3, c);
});
var secondaryLight =
/*#__PURE__*/
th('secondary', function (c) {
  return lighten(0.3, c);
});
var yikTextDark = '#111';
var yikTextLight = '#fff';
var colorVariants = ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'dark']; // System

var colors =
/*#__PURE__*/
['white', 'gray100', 'gray200', 'gray300', 'gray400', 'gray500', 'gray600', 'gray700', 'gray800', 'gray900', 'black', 'blue', 'indigo', 'purple', 'pink', 'red', 'brick', 'orange', 'yellow', 'green', 'teal', 'cyan', 'primary', 'secondary', 'success', 'info', 'warning', 'danger', 'light', 'dark', 'primaryLight', 'secondaryLight'].reduce(function (obj, v) {
  obj[v] = th(v);
  return obj;
}, {});
var fontSizes = [12, 14, 16, 20, 24, 32, 48, 64, 72];
var spaces = [0, 8, 16, 24, 32, 40, 48, 56, 64, 72]; // Borders

var borderRadius = '.25rem';
var borderRadiusSm = '.2rem';
var borderRadiusLg = '.3rem';
var borderWidth = '1px'; // Fonts

var fontSizeBase = '1rem';
var fontSizeSm =
/*#__PURE__*/
th('fontSizeBase', function (fontSize) {
  return modularScale(-1, fontSize);
});
var fontSizeLg =
/*#__PURE__*/
th('fontSizeBase', function (fontSize) {
  return modularScale(1, fontSize);
});
var fontWeightLight = 300;
var fontWeightNormal = 400;
var fontWeightBold = 700;
var lineHeightBase = 1.5;
var lineHeightSm = 1.5;
var lineHeightLg = 1.5; // Input + Buttons

var inputBtnPaddingY = '.375rem';
var inputBtnPaddingX = '.75rem';
var inputBtnLineHeight =
/*#__PURE__*/
th('lineHeightBase');
var inputBtnPaddingYSm = '.25rem';
var inputBtnPaddingXSm = '.5rem';
var inputBtnLineHeightSm =
/*#__PURE__*/
th('lineHeightSm');
var inputBtnPaddingYLg = '.5rem';
var inputBtnPaddingXLg = '1rem';
var inputBtnLineHeightLg =
/*#__PURE__*/
th('lineHeightLg');
var inputBtnBorderWidth =
/*#__PURE__*/
th('borderWidth'); // Buttons

var btnPaddingY =
/*#__PURE__*/
th('inputBtnPaddingY');
var btnPaddingX =
/*#__PURE__*/
th('inputBtnPaddingX');
var btnLineHeight =
/*#__PURE__*/
th('inputBtnLineHeight');
var btnPaddingYSm =
/*#__PURE__*/
th('inputBtnPaddingYSm');
var btnPaddingXSm =
/*#__PURE__*/
th('inputBtnPaddingXSm');
var btnLineHeightSm =
/*#__PURE__*/
th('inputBtnLineHeightSm');
var btnPaddingYLg =
/*#__PURE__*/
th('inputBtnPaddingYLg');
var btnPaddingXLg =
/*#__PURE__*/
th('inputBtnPaddingXLg');
var btnLineHeightLg =
/*#__PURE__*/
th('inputBtnLineHeightLg');
var btnBorderWidth = 0;
var btnDisabledOpacity = 0.8; // Inputs

var inputPaddingY =
/*#__PURE__*/
th('inputBtnPaddingY');
var inputPaddingX =
/*#__PURE__*/
th('inputBtnPaddingX');
var inputLineHeight =
/*#__PURE__*/
th('inputBtnLineHeight');
var inputPaddingYSm =
/*#__PURE__*/
th('inputBtnPaddingYSm');
var inputPaddingXSm =
/*#__PURE__*/
th('inputBtnPaddingXSm');
var inputLineHeightSm =
/*#__PURE__*/
th('inputBtnLineHeightSm');
var inputPaddingYLg =
/*#__PURE__*/
th('inputBtnPaddingYLg');
var inputPaddingXLg =
/*#__PURE__*/
th('inputBtnPaddingXLg');
var inputLineHeightLg =
/*#__PURE__*/
th('inputBtnLineHeightLg');
var inputBorderWidth =
/*#__PURE__*/
th('inputBtnBorderWidth');
var inputBorderColor =
/*#__PURE__*/
th('gray300');
var inputBgColor =
/*#__PURE__*/
th('white');
var inputDisabledBgColor =
/*#__PURE__*/
th('gray100');
var inputDisabledText =
/*#__PURE__*/
th('gray600');
var inputPlaceholderText =
/*#__PURE__*/
th('gray600');
var inputTextColor =
/*#__PURE__*/
th('gray900'); // Controls

var controlFocusBorderColor =
/*#__PURE__*/
th('primary', function (color) {
  return lighten(0.25, color);
});
var controlFocusBoxShadow = function controlFocusBoxShadow(p) {
  return function (color) {
    return "0 0 0 0.2rem " + th(color, function (c) {
      return transparentize(0.75, c);
    })(p);
  };
}; // Grid

var gridColumns = 12;
var gridGutter = 8;
var gridMaxWidths = {
  sm: '540px',
  md: '720px',
  lg: '960px',
  xl: '1140px' // Alerts

};
var alertPaddingY = '.75rem';
var alertPaddingX = '1.25rem';
var alertMarginBottom = '1rem';
var alertBgLevel = -10;
var alertBorderLevel = -9;
var alertColorLevel = 6;
var alertVariant = function alertVariant(p) {
  return function (baseColorTheme) {
    var baseColor = th(baseColorTheme)(p);
    var alertColorLevel = th('alertColorLevel')(p);
    var alertBgLevel = th('alertBgLevel')(p);
    var alertBorderLevel = th('alertBorderLevel')(p);
    return {
      color: mixin('colorLevel', baseColor, alertColorLevel)(p),
      backgroundColor: mixin('colorLevel', baseColor, alertBgLevel)(p),
      borderColor: mixin('colorLevel', baseColor, alertBorderLevel)(p),
      hr: {
        borderTopColor: darken(0.05, mixin('colorLevel', baseColor, alertColorLevel)(p))
      }
    };
  };
}; // Z-indexes

var zIndexControl = 1;
var zIndexInnerSwitch = 10;
var zIndexModal = 1050;
var zIndexModalBackdrop = 1071; // Transitions

var transitionEnabled = true;
var transition = function transition(p) {
  return function (value) {
    return p.theme.transitionEnabled ?
    /*#__PURE__*/
    css$1("transition:", value, ";@media screen and (prefers-reduced-motion:reduce){transition:none;}") : '';
  };
};
var safeTransitionProperties = ['color', 'border-style', 'visibility', 'background', 'background-color', 'text-decoration', 'box-shadow', 'transform', 'opacity'];
var transitionBase =
/*#__PURE__*/
mixin('transition',
/*#__PURE__*/
safeTransitionProperties.map(function (prop$$1) {
  return prop$$1 + " .2s ease-in-out";
}).join(',')); // Breakpoints

var breakpoints = DEFAULT_BREAKPOINTS; // Color levels

var yiqContrastedThreshold = 150;
var colorInterval = 0.08; // Headings

var headingsMarginBottom = '.5rem';
var headingsFontFamily =
/*#__PURE__*/
th('fontFamily');
var headingsFontWeight = 500;
var headingsLineHeight = 1.2;
var headingsColor = 'inherit';
var h1FontSize = '2.5rem';
var h2FontSize = '2rem';
var h3FontSize = '1.75rem';
var h4FontSize = '1.5rem';
var h5FontSize = '1.25rem';
var h6FontSize = '1rem';
var display1Size = '6rem';
var display2Size = '5.5rem';
var display3Size = '4.4rem';
var display4Size = '3.5rem';
var display1Weight = 300;
var display2Weight = 300;
var display3Weight = 300;
var display4Weight = 300;
var displayLineHeight =
/*#__PURE__*/
th('headingsLineHeight'); // Modals

var modalBackdropBg = 'rgba(0, 0, 0, 0.5)';
var modalInnerPadding = '1rem';
var modalTransitionDuration = 300; // ms

var modalDialogMargin = '0.5rem';
var modalDialogMarginYSmUp = '1.75rem';
var modalContentBg =
/*#__PURE__*/
th('white');
var modalContentBorderWidth =
/*#__PURE__*/
th('borderWidth');
var modalContentBorderColor =
/*#__PURE__*/
th('black', function (color) {
  return transparentize(0.8, color);
});
var modalContentBorderRadius =
/*#__PURE__*/
th('borderRadiusLg');
var modalContentBoxShadowXs =
/*#__PURE__*/
css$1("0 .25rem .5rem ",
/*#__PURE__*/
th('black', function (color) {
  return transparentize(0.8, color);
}));
var modalContentBoxShadowSmUp =
/*#__PURE__*/
css$1("0 .5rem 1rem ",
/*#__PURE__*/
th('black', function (color) {
  return transparentize(0.8, color);
}));
var modalHeaderBorderColor =
/*#__PURE__*/
th('gray200');
var modalFooterBorderColor =
/*#__PURE__*/
th('modalHeaderBorderColor');
var modalHeaderBorderWidth =
/*#__PURE__*/
th('modalContentBorderWidth');
var modalFooterBorderWidth =
/*#__PURE__*/
th('modalHeaderBorderWidth'); // Mixins

var base = function base() {
  return function () {
    return (
      /*#__PURE__*/
      css$1("box-sizing:border-box;font-family:", th('fontFamily'), ";font-size:", th('fontSizeBase'), ";line-height:", th('lineHeightBase'), ";*{box-sizing:border-box;}")
    );
  };
};
var controlFocus = function controlFocus(props) {
  return function (baseColor) {
    if (baseColor === void 0) {
      baseColor = 'primary';
    }

    return (
      /*#__PURE__*/
      css$1("outline:0;box-shadow:0 0 2px ", th(baseColor, function (color) {
        return transparentize(0.1, color);
      }), ";")
    );
  };
};
var btnVariant = function btnVariant(props) {
  return function (baseColor) {
    return (
      /*#__PURE__*/
      css$1("color:", mixin('colorYik', th(baseColor)), ";background-color:", th(baseColor), ";&:focus{", mixin('controlFocus', baseColor), ";}&:not(:disabled):hover,&:not(:disabled):active{background-color:", th(baseColor, function (color) {
        return darken(0.05, color);
      }), ";}")
    );
  };
};
var colorLevel = function colorLevel(props) {
  return function (color, level) {
    color = typeof color === 'function' ? color(props) : color;
    level = typeof level === 'function' ? level(props) : level;
    var baseColor = level > 0 ? th('black')(props) : th('white')(props);
    var absLevel = Math.abs(level);
    return mix(absLevel * colorInterval, baseColor, color);
  };
};
var colorYik = function colorYik(props) {
  return function (color) {
    color = typeof color === 'function' ? color(props) : color;

    var _parseToRgb = parseToRgb(color),
        r = _parseToRgb.red,
        g = _parseToRgb.green,
        b = _parseToRgb.blue;

    var yik = (r * 299 + g * 587 + b * 114) / 1000;
    return yik >= th('yiqContrastedThreshold')(props) ? th('yikTextDark')(props) : th('yikTextLight')(props);
  };
};

var theme = /*#__PURE__*/Object.freeze({
  fontFamily: fontFamily,
  white: white,
  gray100: gray100,
  gray200: gray200,
  gray300: gray300,
  gray400: gray400,
  gray500: gray500,
  gray600: gray600,
  gray700: gray700,
  gray800: gray800,
  gray900: gray900,
  black: black,
  blue: blue,
  indigo: indigo,
  purple: purple,
  pink: pink,
  red: red,
  brick: brick,
  orange: orange,
  yellow: yellow,
  green: green,
  teal: teal,
  cyan: cyan,
  primary: primary,
  secondary: secondary,
  success: success,
  info: info,
  warning: warning,
  danger: danger,
  light: light,
  dark: dark,
  primaryLight: primaryLight,
  secondaryLight: secondaryLight,
  yikTextDark: yikTextDark,
  yikTextLight: yikTextLight,
  colorVariants: colorVariants,
  colors: colors,
  fontSizes: fontSizes,
  spaces: spaces,
  borderRadius: borderRadius,
  borderRadiusSm: borderRadiusSm,
  borderRadiusLg: borderRadiusLg,
  borderWidth: borderWidth,
  fontSizeBase: fontSizeBase,
  fontSizeSm: fontSizeSm,
  fontSizeLg: fontSizeLg,
  fontWeightLight: fontWeightLight,
  fontWeightNormal: fontWeightNormal,
  fontWeightBold: fontWeightBold,
  lineHeightBase: lineHeightBase,
  lineHeightSm: lineHeightSm,
  lineHeightLg: lineHeightLg,
  inputBtnPaddingY: inputBtnPaddingY,
  inputBtnPaddingX: inputBtnPaddingX,
  inputBtnLineHeight: inputBtnLineHeight,
  inputBtnPaddingYSm: inputBtnPaddingYSm,
  inputBtnPaddingXSm: inputBtnPaddingXSm,
  inputBtnLineHeightSm: inputBtnLineHeightSm,
  inputBtnPaddingYLg: inputBtnPaddingYLg,
  inputBtnPaddingXLg: inputBtnPaddingXLg,
  inputBtnLineHeightLg: inputBtnLineHeightLg,
  inputBtnBorderWidth: inputBtnBorderWidth,
  btnPaddingY: btnPaddingY,
  btnPaddingX: btnPaddingX,
  btnLineHeight: btnLineHeight,
  btnPaddingYSm: btnPaddingYSm,
  btnPaddingXSm: btnPaddingXSm,
  btnLineHeightSm: btnLineHeightSm,
  btnPaddingYLg: btnPaddingYLg,
  btnPaddingXLg: btnPaddingXLg,
  btnLineHeightLg: btnLineHeightLg,
  btnBorderWidth: btnBorderWidth,
  btnDisabledOpacity: btnDisabledOpacity,
  inputPaddingY: inputPaddingY,
  inputPaddingX: inputPaddingX,
  inputLineHeight: inputLineHeight,
  inputPaddingYSm: inputPaddingYSm,
  inputPaddingXSm: inputPaddingXSm,
  inputLineHeightSm: inputLineHeightSm,
  inputPaddingYLg: inputPaddingYLg,
  inputPaddingXLg: inputPaddingXLg,
  inputLineHeightLg: inputLineHeightLg,
  inputBorderWidth: inputBorderWidth,
  inputBorderColor: inputBorderColor,
  inputBgColor: inputBgColor,
  inputDisabledBgColor: inputDisabledBgColor,
  inputDisabledText: inputDisabledText,
  inputPlaceholderText: inputPlaceholderText,
  inputTextColor: inputTextColor,
  controlFocusBorderColor: controlFocusBorderColor,
  controlFocusBoxShadow: controlFocusBoxShadow,
  gridColumns: gridColumns,
  gridGutter: gridGutter,
  gridMaxWidths: gridMaxWidths,
  alertPaddingY: alertPaddingY,
  alertPaddingX: alertPaddingX,
  alertMarginBottom: alertMarginBottom,
  alertBgLevel: alertBgLevel,
  alertBorderLevel: alertBorderLevel,
  alertColorLevel: alertColorLevel,
  alertVariant: alertVariant,
  zIndexControl: zIndexControl,
  zIndexInnerSwitch: zIndexInnerSwitch,
  zIndexModal: zIndexModal,
  zIndexModalBackdrop: zIndexModalBackdrop,
  transitionEnabled: transitionEnabled,
  transition: transition,
  transitionBase: transitionBase,
  breakpoints: breakpoints,
  yiqContrastedThreshold: yiqContrastedThreshold,
  colorInterval: colorInterval,
  headingsMarginBottom: headingsMarginBottom,
  headingsFontFamily: headingsFontFamily,
  headingsFontWeight: headingsFontWeight,
  headingsLineHeight: headingsLineHeight,
  headingsColor: headingsColor,
  h1FontSize: h1FontSize,
  h2FontSize: h2FontSize,
  h3FontSize: h3FontSize,
  h4FontSize: h4FontSize,
  h5FontSize: h5FontSize,
  h6FontSize: h6FontSize,
  display1Size: display1Size,
  display2Size: display2Size,
  display3Size: display3Size,
  display4Size: display4Size,
  display1Weight: display1Weight,
  display2Weight: display2Weight,
  display3Weight: display3Weight,
  display4Weight: display4Weight,
  displayLineHeight: displayLineHeight,
  modalBackdropBg: modalBackdropBg,
  modalInnerPadding: modalInnerPadding,
  modalTransitionDuration: modalTransitionDuration,
  modalDialogMargin: modalDialogMargin,
  modalDialogMarginYSmUp: modalDialogMarginYSmUp,
  modalContentBg: modalContentBg,
  modalContentBorderWidth: modalContentBorderWidth,
  modalContentBorderColor: modalContentBorderColor,
  modalContentBorderRadius: modalContentBorderRadius,
  modalContentBoxShadowXs: modalContentBoxShadowXs,
  modalContentBoxShadowSmUp: modalContentBoxShadowSmUp,
  modalHeaderBorderColor: modalHeaderBorderColor,
  modalFooterBorderColor: modalFooterBorderColor,
  modalHeaderBorderWidth: modalHeaderBorderWidth,
  modalFooterBorderWidth: modalFooterBorderWidth,
  base: base,
  controlFocus: controlFocus,
  btnVariant: btnVariant,
  colorLevel: colorLevel,
  colorYik: colorYik
});

var composeStyles$1 = function composeStyles() {
  for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }

  var stylesByProp = styles.reduce(function (props, systemStyle) {
    if (systemStyle.meta) {
      systemStyle.meta.props.forEach(function (prop) {
        props[prop] = systemStyle;
      });
    }

    return props;
  }, {});

  var composedStyle = function composedStyle(props) {
    var propKeys = Object.keys(props);
    var propCount = propKeys.length;
    var style = {};

    for (var i = 0; i < propCount; i += 1) {
      var propKey = propKeys[i];
      var systemStyle = stylesByProp[propKey];

      if (systemStyle) {
        var _systemStyle;

        style = merge(style, systemStyle((_systemStyle = {}, _systemStyle[propKey] = props[propKey], _systemStyle.theme = props.theme, _systemStyle)));
      }
    }

    return style;
  };

  composedStyle.meta = {
    props: styles.reduce(function (keys, systemStyle) {
      return [].concat(keys, systemStyle.meta.props);
    }, [])
  };
  composedStyle.propTypes = styles.map(function (systemStyle) {
    return systemStyle.propTypes;
  }).reduce(merge, {});
  return composedStyle;
};

var properties = {
  m: 'margin',
  p: 'padding'
};
var directions = {
  t: 'Top',
  r: 'Right',
  b: 'Bottom',
  l: 'Left',
  x: ['Left', 'Right'],
  y: ['Top', 'Bottom']
};
var spaceKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'p', 'pt', 'pr', 'pb', 'pl', 'px', 'py'];

var getProperties = function getProperties(key) {
  var _key$split = key.split(''),
      a = _key$split[0],
      b = _key$split[1];

  var property = properties[a];
  var direction = directions[b] || '';
  return Array.isArray(direction) ? direction.map(function (dir) {
    return property + dir;
  }) : [property + direction];
};

var getValue = function getValue(variants) {
  return function (n) {
    if (!num(n)) {
      return variants[n] || n;
    }

    var abs = Math.abs(n);
    var neg = negative(n);
    var value = variants[abs] || abs;

    if (!num(value)) {
      return neg ? "-" + value : value;
    }

    return px(value * (neg ? -1 : 1));
  };
};

var space = function space(props) {
  var keys = Object.keys(props).filter(function (key) {
    return spaceKeys.includes(key);
  }).sort();
  if (!keys.length) return null;
  var variants = lazyTh('spaces')(props) || {};
  var getStyle = getValue(variants);
  return keys.map(function (key) {
    var value = props[key];
    var properties = getProperties(key);

    var styleFromValue = function styleFromValue(n) {
      return is(n) ? properties.reduce(function (a, prop$$1) {
        var _objectSpread2;

        return _objectSpread({}, a, (_objectSpread2 = {}, _objectSpread2[prop$$1] = getStyle(n), _objectSpread2));
      }, {}) : null;
    };

    if (string(value) || num(value)) {
      return styleFromValue(value);
    }

    if (obj(value)) {
      return Object.keys(value).map(function (breakpoint) {
        var _ref;

        var style$$1 = styleFromValue(value[breakpoint]);
        if (!style$$1) return null;
        var breakpointValue = getBreakpointMin(breakpoint, props);
        if (breakpointValue === null) return style$$1;
        return _ref = {}, _ref[mediaMinWidth(breakpointValue)] = style$$1, _ref;
      }).reduce(merge, {});
    }

    return null;
  }).reduce(merge, {});
};

space.propTypes =
/*#__PURE__*/
spaceKeys.reduce(function (obj$$1, key) {
  obj$$1[key] = stylePropType;
  return obj$$1;
}, {});
space.meta = {
  props: spaceKeys
};

var opacity =
/*#__PURE__*/
style({
  prop: 'opacity'
});
var overflow =
/*#__PURE__*/
style({
  prop: 'overflow'
});
var basics =
/*#__PURE__*/
composeStyles$1(opacity, overflow); // Typography

var fontFamily$1 =
/*#__PURE__*/
style({
  prop: 'fontFamily',
  variants: 'fonts'
});
var fontSize =
/*#__PURE__*/
style({
  prop: 'fontSize',
  variants: 'fontSizes',
  transform: px
});
var lineHeight =
/*#__PURE__*/
style({
  prop: 'lineHeight',
  variants: 'lineHeights'
});
var fontWeight =
/*#__PURE__*/
style({
  prop: 'fontWeight',
  variants: 'fontWeights'
});
var textAlign =
/*#__PURE__*/
style({
  prop: 'textAlign'
});
var letterSpacing =
/*#__PURE__*/
style({
  prop: 'letterSpacing',
  variants: 'letterSpacings',
  transform: px
});
var color =
/*#__PURE__*/
style({
  prop: 'color',
  variants: 'colors'
});
var typography =
/*#__PURE__*/
composeStyles$1(fontFamily$1, fontSize, lineHeight, fontWeight, textAlign, letterSpacing, color); // Dimensions

var getDimension = function getDimension(n) {
  return !num(n) || n > 1 ? px(n) : n * 100 + "%";
};

var width =
/*#__PURE__*/
style({
  prop: 'width',
  transform: getDimension,
  variants: 'widths'
});
var height =
/*#__PURE__*/
style({
  prop: 'height',
  transform: getDimension,
  variants: 'heights'
});
var maxWidth =
/*#__PURE__*/
style({
  prop: 'maxWidth',
  transform: getDimension,
  variants: 'widths'
});
var maxHeight =
/*#__PURE__*/
style({
  prop: 'maxHeight',
  transform: getDimension,
  variants: 'heights'
});
var minWidth =
/*#__PURE__*/
style({
  prop: 'minWidth',
  transform: getDimension,
  variants: 'widths'
});
var minHeight =
/*#__PURE__*/
style({
  prop: 'minHeight',
  transform: getDimension,
  variants: 'heights'
});
var dimensions =
/*#__PURE__*/
composeStyles$1(width, height, maxWidth, maxHeight, minWidth, minHeight); // Space

var display =
/*#__PURE__*/
style({
  prop: 'display'
});
var alignItems =
/*#__PURE__*/
style({
  prop: 'alignItems'
});
var alignContent =
/*#__PURE__*/
style({
  prop: 'alignContent'
});
var justifyContent =
/*#__PURE__*/
style({
  prop: 'justifyContent'
});
var flexWrap =
/*#__PURE__*/
style({
  prop: 'flexWrap'
});
var flexBasis =
/*#__PURE__*/
style({
  prop: 'flexBasis',
  transform: getDimension
});
var flexDirection =
/*#__PURE__*/
style({
  prop: 'flexDirection'
});
var flex =
/*#__PURE__*/
style({
  prop: 'flex'
});
var justifySelf =
/*#__PURE__*/
style({
  prop: 'justifySelf'
});
var alignSelf =
/*#__PURE__*/
style({
  prop: 'alignSelf'
});
var order =
/*#__PURE__*/
style({
  prop: 'order'
});
var flexboxes =
/*#__PURE__*/
composeStyles$1(display, alignItems, alignContent, justifyContent, flexWrap, flexBasis, flexDirection, flex, justifySelf, alignSelf, order); // Background

var background =
/*#__PURE__*/
style({
  prop: 'background'
});
var backgroundColor =
/*#__PURE__*/
style({
  prop: 'backgroundColor',
  variants: 'colors'
});
var backgroundImage =
/*#__PURE__*/
style({
  prop: 'backgroundImage'
});
var backgroundSize =
/*#__PURE__*/
style({
  prop: 'backgroundSize'
});
var backgroundPosition =
/*#__PURE__*/
style({
  prop: 'backgroundPosition'
});
var backgroundRepeat =
/*#__PURE__*/
style({
  prop: 'backgroundRepeat'
});
var backgrounds =
/*#__PURE__*/
composeStyles$1(background, backgroundColor, backgroundImage, backgroundSize, backgroundPosition, backgroundRepeat); // Position

var position =
/*#__PURE__*/
style({
  prop: 'position'
});
var zIndex =
/*#__PURE__*/
style({
  prop: 'zIndex',
  variants: 'zIndexes'
});
var top =
/*#__PURE__*/
style({
  prop: 'top',
  transform: px
});
var right =
/*#__PURE__*/
style({
  prop: 'right',
  transform: px
});
var bottom =
/*#__PURE__*/
style({
  prop: 'bottom',
  transform: px
});
var left =
/*#__PURE__*/
style({
  prop: 'left',
  transform: px
});
var positions =
/*#__PURE__*/
composeStyles$1(position, zIndex, top, right, bottom, left); // Border

var getBorder = function getBorder(n) {
  return num(n) && n > 0 ? n + "px solid" : n;
};

var border =
/*#__PURE__*/
style({
  prop: 'border',
  variants: 'borders',
  transform: getBorder
});
var borderTop =
/*#__PURE__*/
style({
  prop: 'borderTop',
  variants: 'borders',
  transform: getBorder
});
var borderRight =
/*#__PURE__*/
style({
  prop: 'borderRight',
  variants: 'borders',
  transform: getBorder
});
var borderBottom =
/*#__PURE__*/
style({
  prop: 'borderBottom',
  variants: 'borders',
  transform: getBorder
});
var borderLeft =
/*#__PURE__*/
style({
  prop: 'borderLeft',
  variants: 'borders',
  transform: getBorder
});
var borderColor =
/*#__PURE__*/
style({
  prop: 'borderColor',
  variants: 'colors'
});
var borderRadius$1 =
/*#__PURE__*/
style({
  prop: 'borderRadius',
  variants: 'radii',
  transform: px
});
var boxShadow =
/*#__PURE__*/
style({
  prop: 'boxShadow',
  variants: 'shadows'
});
var borders =
/*#__PURE__*/
composeStyles$1(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderRadius$1, boxShadow);
var system =
/*#__PURE__*/
composeStyles$1(basics, typography, dimensions, space, flexboxes, backgrounds, positions, borders);

var styles = /*#__PURE__*/Object.freeze({
  opacity: opacity,
  overflow: overflow,
  basics: basics,
  fontFamily: fontFamily$1,
  fontSize: fontSize,
  lineHeight: lineHeight,
  fontWeight: fontWeight,
  textAlign: textAlign,
  letterSpacing: letterSpacing,
  color: color,
  typography: typography,
  width: width,
  height: height,
  maxWidth: maxWidth,
  maxHeight: maxHeight,
  minWidth: minWidth,
  minHeight: minHeight,
  dimensions: dimensions,
  space: space,
  display: display,
  alignItems: alignItems,
  alignContent: alignContent,
  justifyContent: justifyContent,
  flexWrap: flexWrap,
  flexBasis: flexBasis,
  flexDirection: flexDirection,
  flex: flex,
  justifySelf: justifySelf,
  alignSelf: alignSelf,
  order: order,
  flexboxes: flexboxes,
  background: background,
  backgroundColor: backgroundColor,
  backgroundImage: backgroundImage,
  backgroundSize: backgroundSize,
  backgroundPosition: backgroundPosition,
  backgroundRepeat: backgroundRepeat,
  backgrounds: backgrounds,
  position: position,
  zIndex: zIndex,
  top: top,
  right: right,
  bottom: bottom,
  left: left,
  positions: positions,
  border: border,
  borderTop: borderTop,
  borderRight: borderRight,
  borderBottom: borderBottom,
  borderLeft: borderLeft,
  borderColor: borderColor,
  borderRadius: borderRadius$1,
  boxShadow: boxShadow,
  borders: borders,
  system: system
});

function createComponent(getConfig) {
  var _getConfig = getConfig(),
      name = _getConfig.name,
      style = _getConfig.style,
      _getConfig$omitProps = _getConfig.omitProps,
      omitProps = _getConfig$omitProps === void 0 ? [] : _getConfig$omitProps,
      _getConfig$defaultPro = _getConfig.defaultProps,
      defaultProps = _getConfig$defaultPro === void 0 ? {} : _getConfig$defaultPro,
      _getConfig$propTypes = _getConfig.propTypes,
      propTypes = _getConfig$propTypes === void 0 ? {} : _getConfig$propTypes,
      _getConfig$render = _getConfig.render,
      _render = _getConfig$render === void 0 ? function (_ref) {
    var Component = _ref.Component,
        props = _objectWithoutPropertiesLoose(_ref, ["Component"]);

    return React.createElement(Component, props);
  } : _getConfig$render,
      _getConfig$defaultCom = _getConfig.defaultComponent,
      defaultComponent = _getConfig$defaultCom === void 0 ? 'div' : _getConfig$defaultCom,
      _getConfig$system = _getConfig.system,
      system$$1 = _getConfig$system === void 0 ? system : _getConfig$system,
      _getConfig$applySyste = _getConfig.applySystem,
      applySystem = _getConfig$applySyste === void 0 ? function (system$$1) {
    return function (props) {
      return {
        '&&': system$$1(props)
      };
    };
  } : _getConfig$applySyste,
      injectTheme = _getConfig.injectTheme,
      InnerComponentFromConfig = _getConfig.InnerComponent;

  var omittedProps = ['theme'].concat(system$$1 ? system$$1.meta.props : {}, omitProps);
  var baseClassName = "sui-" + name;

  var InnerComponent = InnerComponentFromConfig ||
  /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose(Component, _React$Component);

    function Component() {
      return _React$Component.apply(this, arguments) || this;
    }

    var _proto = Component.prototype;

    _proto.render = function render() {
      var _this$props = this.props,
          className = _this$props.className,
          forwardedAs = _this$props.forwardedAs,
          as = _this$props.as,
          theme = _this$props.theme,
          forwardedRef = _this$props.forwardedRef,
          props = _objectWithoutPropertiesLoose(_this$props, ["className", "forwardedAs", "as", "theme", "forwardedRef"]);

      var Component = forwardedAs || as || defaultComponent;

      var renderProps = _objectSpread({
        ref: forwardedRef,
        Component: Component,
        className: className ? baseClassName + " " + className : baseClassName
      }, omit(props, omittedProps));

      if (injectTheme) {
        renderProps.theme = theme;
      }

      return _render(renderProps);
    };

    return Component;
  }(React.Component);

  InnerComponent = injectTheme ? withTheme$1(InnerComponent) : InnerComponent;
  InnerComponent.displayName = "sui-" + name;

  function forwardRef(props, ref) {
    return React.createElement(InnerComponent, _extends({}, props, {
      forwardedRef: ref
    }));
  }

  forwardRef.displayName = InnerComponent.displayName;
  var RefComponent = React.forwardRef(forwardRef);
  RefComponent.displayName = InnerComponent.displayName; // eslint-disable-next-line no-underscore-dangle

  RefComponent.__smoothUIComponent = true;
  var StyledComponent =
  /*#__PURE__*/
  styled(RefComponent, {
    target: "e1sssgrs0"
  })(style, ";", applySystem && applySystem(system$$1), ";");
  StyledComponent.propTypes = _objectSpread({
    theme: PropTypes.object
  }, system$$1 ? system$$1.propTypes : {}, propTypes);
  StyledComponent.defaultProps = _objectSpread({
    theme: theme
  }, defaultProps);
  return StyledComponent;
}

var Alert =
/*#__PURE__*/
createComponent(function () {
  return {
    name: 'alert',
    omitProps: ['variant'],
    style:
    /*#__PURE__*/
    css$1("position:relative;padding:", th('alertPaddingY'), " ", th('alertPaddingX'), ";margin-bottom:", th('alertMarginBottom'), ";border:1px solid transparent;border-radius:", th('borderRadius'), ";", function (p) {
      return p.variant && mixin('alertVariant', p.variant)(p);
    }, ";"),
    propTypes: {
      children: PropTypes.node,
      variant: PropTypes.string
    },
    defaultProps: {
      variant: 'primary'
    }
  };
});

var Box =
/*#__PURE__*/
createComponent(function () {
  return {
    name: 'box'
  };
});

var Breakpoint =
/*#__PURE__*/
createComponent(function () {
  return {
    name: 'breakpoint',
    omitProps: ['up', 'down'],
    style:
    /*#__PURE__*/
    css$1("display:none;", function (p) {
      return p.up && up(p.up, 'display: block;');
    }, ";", function (p) {
      return p.down && down(p.down, 'display: block;');
    }, ";"),
    propTypes: {
      children: PropTypes.node,
      up: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
      down: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
    }
  };
});

var sizeStyle = {
  sm:
  /*#__PURE__*/
  css$1("padding:",
  /*#__PURE__*/
  th('btnPaddingYSm'), " ",
  /*#__PURE__*/
  th('btnPaddingXSm'), ";font-size:",
  /*#__PURE__*/
  th('fontSizeSm'), ";border-radius:",
  /*#__PURE__*/
  th('borderRadiusSm'), ";line-height:",
  /*#__PURE__*/
  th('btnLineHeightSm'), ";"),
  md:
  /*#__PURE__*/
  css$1("padding:",
  /*#__PURE__*/
  th('btnPaddingY'), " ",
  /*#__PURE__*/
  th('btnPaddingX'), ";font-size:",
  /*#__PURE__*/
  th('fontSizeBase'), ";border-radius:",
  /*#__PURE__*/
  th('borderRadius'), ";line-height:",
  /*#__PURE__*/
  th('btnLineHeight'), ";"),
  lg:
  /*#__PURE__*/
  css$1("padding:",
  /*#__PURE__*/
  th('btnPaddingYLg'), " ",
  /*#__PURE__*/
  th('btnPaddingXLg'), ";font-size:",
  /*#__PURE__*/
  th('fontSizeLg'), ";border-radius:",
  /*#__PURE__*/
  th('borderRadiusLg'), ";line-height:",
  /*#__PURE__*/
  th('btnLineHeightLg'), ";")
};
var Button =
/*#__PURE__*/
createComponent(function () {
  return {
    name: 'button',
    defaultComponent: 'button',
    omitProps: ['size', 'variant'],
    style:
    /*#__PURE__*/
    css$1("display:inline-block;padding:", th('btnPaddingY'), " ", th('btnPaddingX'), ";z-index:", th('zIndexControl'), ";border-radius:", th('borderRadius'), ";font-size:", th('fontSizeBase'), ";line-height:", th('btnLineHeight'), ";border-width:", th('btnBorderWidth'), ";cursor:pointer;", th('transitionBase'), ";text-decoration:none;&:disabled{opacity:", th('btnDisabledOpacity'), ";}", function (p) {
      return p.size && sizeStyle[p.size];
    }, ";", function (p) {
      return p.variant && mixin('btnVariant', p.variant)(p);
    }, ";"),
    propTypes: {
      children: PropTypes.node,
      disabled: PropTypes.bool,
      size: PropTypes.oneOf(['sm', 'md', 'lg']),
      variant: PropTypes.string
    },
    defaultProps: {
      size: 'md',
      variant: 'primary'
    }
  };
});

var SwitchState =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(SwitchState, _React$Component);

  function SwitchState() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      focused: false,
      checked: _this.props.checked || _this.props.defaultChecked || false
    };

    _this.handleChange = function (event) {
      if (_this.props.checked === undefined) {
        _this.setState({
          checked: event.currentTarget.checked
        });
      }

      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    };

    _this.handleFocus = function (event) {
      _this.setState({
        focused: true
      });

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    };

    _this.handleBlur = function (event) {
      _this.setState({
        focused: false
      });

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    };

    return _this;
  }

  SwitchState.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (props.checked !== undefined && props.checked !== state.checked) {
      return _objectSpread({}, state, {
        checked: props.checked
      });
    }

    return state;
  };

  var _proto = SwitchState.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        checked = _this$props.checked,
        children = _this$props.children,
        defaultChecked = _this$props.defaultChecked,
        onChange = _this$props.onChange,
        onBlur = _this$props.onBlur,
        onFocus = _this$props.onFocus,
        style = _this$props.style,
        props = _objectWithoutPropertiesLoose(_this$props, ["checked", "children", "defaultChecked", "onChange", "onBlur", "onFocus", "style"]);

    return this.props.children({
      focused: this.state.focused,
      checked: this.state.checked,
      disabled: props.disabled,
      input: _objectSpread({
        checked: this.state.checked,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        style: _objectSpread({
          position: 'absolute',
          margin: 0,
          padding: 0,
          top: 0,
          right: 0,
          left: 0,
          bottom: 0,
          opacity: 0,
          width: '100%',
          height: '100%',
          zIndex: 10
        }, style)
      }, props)
    });
  };

  return SwitchState;
}(React.Component);

var sizeStyle$1 = {
  sm:
  /*#__PURE__*/
  css$1(".sui-checkbox-content{border-radius:",
  /*#__PURE__*/
  th('borderRadiusSm'), ";width:0.875rem;height:0.875rem;}.sui-checkbox-check{width:8px;height:8px;}"),
  md:
  /*#__PURE__*/
  css$1(".sui-checkbox-content{border-radius:",
  /*#__PURE__*/
  th('borderRadius'), ";width:1rem;height:1rem;}.sui-checkbox-check{width:10px;height:10px;}"),
  lg:
  /*#__PURE__*/
  css$1(".sui-checkbox-content{border-radius:",
  /*#__PURE__*/
  th('borderRadiusLg'), ";width:1.25rem;height:1.25rem;}.sui-checkbox-check{width:12px;height:12px;}")
};
var containerSystem =
/*#__PURE__*/
composeStyles$1(basics, dimensions, space, flexboxes, positions);
var contentSystem =
/*#__PURE__*/
composeStyles$1(dimensions, backgrounds, borders);
var Checkbox =
/*#__PURE__*/
createComponent(function () {
  return {
    name: 'checkbox',
    system: composeStyles$1(containerSystem, contentSystem),
    applySystem: null,
    render: function render(_ref) {
      var Component = _ref.Component,
          ref = _ref.ref,
          className = _ref.className,
          size = _ref.size,
          props = _objectWithoutPropertiesLoose(_ref, ["Component", "ref", "className", "size"]);

      return React.createElement(SwitchState, props, function (_ref2) {
        var input = _ref2.input;
        return React.createElement(Component, {
          className: className
        }, React.createElement("input", _extends({
          ref: ref,
          type: "checkbox"
        }, input)), React.createElement("div", {
          className: "sui-checkbox-content"
        }, React.createElement("svg", {
          className: "sui-checkbox-check",
          viewBox: "0 0 512 512"
        }, React.createElement("path", {
          fill: "currentColor",
          d: "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
        }))));
      });
    },
    style:
    /*#__PURE__*/
    css$1("display:inline-flex;align-items:center;justify-content:center;position:relative;width:1.5rem;height:1.5rem;z-index:", th('zIndexControl'), ";.sui-checkbox-check{pointer-events:none;transform:scale(0);transform-origin:center;color:", th('white'), ";", th('transitionBase'), ";}.sui-checkbox-content{display:flex;align-items:center;justify-content:center;width:1rem;height:1rem;background-color:", th('inputBgColor'), ";border-radius:", th('borderRadius'), ";border-style:solid;border-width:", th('inputBorderWidth'), ";border-color:", th('inputBorderColor'), ";", th('transitionBase'), ";}input:checked + .sui-checkbox-content{background-color:", th('primary'), ";border-color:transparent;svg{transform:scale(1);}}input:focused + .sui-checkbox-content{", mixin('controlFocus'), ";}input:disabled + .sui-checkbox-content{background-color:", th('inputDisabledBgColor'), ";}", function (p) {
      return sizeStyle$1[p.size];
    }, ";", containerSystem, ";.sui-checkbox-content{", contentSystem, ";}"),
    propTypes: {
      checked: PropTypes.bool,
      disabled: PropTypes.bool,
      onChange: PropTypes.func,
      size: PropTypes.oneOf(['sm', 'md', 'lg']),
      value: PropTypes.string
    },
    defaultProps: {
      size: 'md'
    }
  };
});

var common = {
  position: 'relative',
  width: '100%',
  minHeight: '1px'
};

function isValidSize(size) {
  return size || size === 0;
}

function getSizeWidth(size, nbColumns) {
  return Math.round(size / nbColumns * Math.pow(10, 6)) / Math.pow(10, 4) + "%";
}

function getOffsetStyle(offsetSize, nbColumns) {
  if (isValidSize(offsetSize)) {
    var marginLeft = getSizeWidth(offsetSize, nbColumns);
    return {
      marginLeft: marginLeft
    };
  }

  return null;
}

function getBreakPointStyle(breakpoint, width, props) {
  var size = props[breakpoint];
  if (!isValidSize(size)) return null;
  var nbColumns = props.theme.gridColumns;
  var mediaQuery = mediaMinWidth(width);

  var media = function media(style$$1) {
    var _ref;

    return width === 0 ? style$$1 : (_ref = {}, _ref[mediaQuery] = style$$1, _ref);
  };

  if (size === true) {
    return _objectSpread({}, common, media({
      flexBasis: 0,
      flexGrow: 1,
      maxWidth: '100%'
    }));
  }

  if (size === 'auto') {
    return _objectSpread({}, common, media({
      flex: "0 0 auto",
      maxWidth: 'none',
      width: 'auto'
    }));
  }

  var sizeWidth = getSizeWidth(size, nbColumns);
  return _objectSpread({}, common, media(_objectSpread({
    flex: "0 0 " + sizeWidth,
    maxWidth: sizeWidth
  }, getOffsetStyle(props["o" + breakpoint], nbColumns))));
}

var getStyleFromProps = function getStyleFromProps(props) {
  var gutter = px(prop('gutter', 'gridGutter')(props));
  var breakpointsKeys = Object.keys(props.theme.breakpoints);
  var style$$1 = {
    paddingLeft: gutter,
    paddingRight: gutter,
    flexBasis: 0,
    flexGrow: 1,
    maxWidth: '100%'
  };
  var index = -1; // eslint-disable-next-line no-plusplus

  while (++index < breakpointsKeys.length) {
    var breakpoint = breakpointsKeys[index];
    Object.assign(style$$1, getBreakPointStyle(breakpoint, props.theme.breakpoints[breakpoint], props));
  }

  return style$$1;
};

var Col =
/*#__PURE__*/
createComponent(function () {
  return {
    name: 'col',
    omitProps: ['xs', 'sm', 'md', 'lg', 'xl', 'oxs', 'osm', 'omd', 'olg', 'oxl'],
    style: getStyleFromProps,
    propTypes: {
      children: PropTypes.node,
      gutter: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      xs: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]),
      sm: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]),
      md: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]),
      lg: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]),
      xl: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]),
      oxs: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      osm: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      omd: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      olg: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      oxl: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }
  };
});
Col.Split =
/*#__PURE__*/
createComponent(function () {
  return {
    name: 'col-split',
    style: function style$$1() {
      return {
        width: '100% !important'
      };
    }
  };
});

var ControlFeedback =
/*#__PURE__*/
createComponent(function () {
  return {
    name: 'control-feedback',
    omitProps: ['valid'],
    style:
    /*#__PURE__*/
    css$1("width:100%;margin-top:0.25rem;font-size:80%;color:", function (p) {
      return p.valid ? th('success')(p) : th('danger')(p);
    }, ";"),
    propTypes: {
      children: PropTypes.node,
      valid: PropTypes.bool.isRequired
    }
  };
});

var FormCheck =
/*#__PURE__*/
createComponent(function () {
  return {
    name: 'form-check',
    omitProps: ['inline'],
    style:
    /*#__PURE__*/
    css$1("display:flex;align-items:center;", function (p) {
      return p.inline &&
      /*#__PURE__*/
      css$1("display:inline-flex;margin-right:0.75rem;");
    }, ";"),
    propTypes: {
      children: PropTypes.node,
      inline: PropTypes.bool
    }
  };
});

var FormCheckLabel =
/*#__PURE__*/
createComponent(function () {
  return {
    name: 'form-check-label',
    defaultComponent: 'label',
    style:
    /*#__PURE__*/
    css$1("padding-left:0.25rem;[class*='disabled'] ~ &{color:", th('inputDisabledText'), ";}"),
    propTypes: {
      children: PropTypes.node
    }
  };
});

var FormGroup =
/*#__PURE__*/
createComponent(function () {
  return {
    name: 'form-group',
    style:
    /*#__PURE__*/
    css$1("margin-bottom:1rem;"),
    propTypes: {
      children: PropTypes.node
    }
  };
});

var styleBreakpoints = function styleBreakpoints(p) {
  var breakpoints = th('breakpoints')(p);
  var gridMaxWidths = th('gridMaxWidths')(p);

  var style$$1 = function style$$1(breakpoint) {
    var width = breakpoints[breakpoint];

    var media = function media(s) {
      var _ref;

      return width === 0 ? s : (_ref = {}, _ref[mediaMinWidth(width)] = s, _ref);
    };

    return media({
      maxWidth: gridMaxWidths[breakpoint]
    });
  };

  return Object.keys(breakpoints).reduce(function (obj, breakpoint) {
    return Object.assign(obj, style$$1(breakpoint));
  }, {});
};

var Grid =
/*#__PURE__*/
createComponent(function () {
  return {
    name: 'grid',
    omitProps: ['gutter', 'fluid'],
    style: function style$$1(p) {
      var gutter = px(prop('gutter', 'gridGutter')(p));
      return _objectSpread({
        width: '100%',
        paddingRight: gutter,
        paddingLeft: gutter,
        marginRight: 'auto',
        marginLeft: 'auto'
      }, p.fluid ? null : styleBreakpoints(p));
    },
    propTypes: {
      children: PropTypes.node,
      gutter: PropTypes.number,
      fluid: PropTypes.bool
    }
  };
});

var sizeStyle$2 = {
  sm:
  /*#__PURE__*/
  css$1("padding:",
  /*#__PURE__*/
  th('inputPaddingYSm'), " ",
  /*#__PURE__*/
  th('inputPaddingXSm'), ";font-size:",
  /*#__PURE__*/
  th('fontSizeSm'), ";border-radius:",
  /*#__PURE__*/
  th('borderRadiusSm'), ";"),
  md:
  /*#__PURE__*/
  css$1("padding:",
  /*#__PURE__*/
  th('inputPaddingY'), " ",
  /*#__PURE__*/
  th('inputPaddingX'), ";font-size:",
  /*#__PURE__*/
  th('fontSizeBase'), ";border-radius:",
  /*#__PURE__*/
  th('borderRadius'), ";"),
  lg:
  /*#__PURE__*/
  css$1("padding:",
  /*#__PURE__*/
  th('inputPaddingYLg'), " ",
  /*#__PURE__*/
  th('inputPaddingXLg'), ";font-size:",
  /*#__PURE__*/
  th('fontSizeLg'), ";border-radius:",
  /*#__PURE__*/
  th('borderRadiusLg'), ";")
};
var validStyle =
/*#__PURE__*/
css$1("border-color:",
/*#__PURE__*/
th('success'), ";&:focus{border-color:",
/*#__PURE__*/
th('success'), ";box-shadow:",
/*#__PURE__*/
mixin('controlFocusBoxShadow', 'success'), ";}");
var invalidStyle =
/*#__PURE__*/
css$1("border-color:",
/*#__PURE__*/
th('danger'), ";&:focus{border-color:",
/*#__PURE__*/
th('danger'), ";box-shadow:",
/*#__PURE__*/
mixin('controlFocusBoxShadow', 'danger'), ";}");
var controlStyle =
/*#__PURE__*/
css$1("display:block;width:100%;&:focus{border-color:",
/*#__PURE__*/
th('controlFocusBorderColor'), ";box-shadow:",
/*#__PURE__*/
mixin('controlFocusBoxShadow', 'primary'), ";}", function (p) {
  switch (p.valid) {
    case true:
      return validStyle;

    case false:
      return invalidStyle;

    default:
      return null;
  }
}, ";");
var Input =
/*#__PURE__*/
createComponent(function () {
  return {
    name: 'input',
    defaultComponent: 'input',
    omitProps: ['control', 'size', 'valid'],
    style:
    /*#__PURE__*/
    css$1("display:inline-block;border-width:", th('inputBorderWidth'), ";border-color:", th('inputBorderColor'), ";border-style:solid;line-height:", th('inputLineHeight'), ";color:", th('inputTextColor'), ";", th('transitionBase'), ";background-color:", th('inputBgColor'), ";&[type='number']{padding-right:6px;}&::placeholder{color:", th('inputPlaceholderText'), ";}&:focus{", mixin('controlFocus'), ";}&:disabled{background-color:", th('inputDisabledBgColor'), ";color:", th('inputDisabledText'), ";}", function (p) {
      return p.size && sizeStyle$2[p.size];
    }, ";", function (p) {
      return p.control && controlStyle;
    }, ";"),
    propTypes: {
      control: PropTypes.bool,
      size: PropTypes.oneOf(['sm', 'md', 'lg']),
      valid: PropTypes.bool
    },
    defaultProps: {
      size: 'md'
    }
  };
});

/* eslint-disable jsx-a11y/label-has-for */
var Label =
/*#__PURE__*/
createComponent(function () {
  return {
    name: 'label',
    defaultComponent: 'label',
    style:
    /*#__PURE__*/
    css$1("display:inline-block;margin-bottom:0.5rem;"),
    propTypes: {
      children: PropTypes.node
    }
  };
});

var Portal =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Portal, _React$Component);

  function Portal() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      node: null
    };
    return _this;
  }

  var _proto = Portal.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var node = document.createElement(this.props.type);
    document.body.appendChild(node);
    this.setState({
      node: node
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    document.body.removeChild(this.state.node);
  };

  _proto.render = function render() {
    return this.state.node ? ReactDOM.createPortal(this.props.children, this.state.node) : null;
  };

  return Portal;
}(React.Component);

Portal.propTypes = {
  type: PropTypes.string,
  children: PropTypes.node
};
Portal.defaultProps = {
  type: 'sui-portal'
};

var ModalContext = /*#__PURE__*/
React.createContext();

var wrapEvent = function wrapEvent(handler, cb) {
  return function (event) {
    if (handler) {
      handler(event);
    }

    if (!event.defaultPrevented) {
      cb(event);
    }
  };
};

var createAriaHider = function createAriaHider(dialogNode) {
  var originalValues = [];
  var rootNodes = [];
  Array.prototype.forEach.call(document.querySelectorAll('body > *'), function (node) {
    if (node === dialogNode.parentNode) {
      return;
    }

    var attr = node.getAttribute('aria-hidden');
    var alreadyHidden = attr !== null && attr !== 'false';

    if (alreadyHidden) {
      return;
    }

    originalValues.push(attr);
    rootNodes.push(node);
    node.setAttribute('aria-hidden', 'true');
  });
  return function () {
    rootNodes.forEach(function (node, index) {
      var originalValue = originalValues[index];

      if (originalValue === null) {
        node.removeAttribute('aria-hidden');
      } else {
        node.setAttribute('aria-hidden', originalValue);
      }
    });
  };
};

var cx$$1 = function cx$$1() {
  for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }

  return classNames.filter(Boolean).join(' ');
};

var ModalComponent =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ModalComponent, _React$Component);

  function ModalComponent() {
    var _this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.contentRef = React.createRef();
    _this.trap = null;
    _this.disposeAriaHider = null;

    _this.handleDialogRef = function (dialogNode) {
      if (dialogNode) {
        _this.disposeAriaHider = createAriaHider(dialogNode);
      } else {
        _this.disposeAriaHider();
      }
    };

    _this.onFocusLockActivation = function () {
      var initialFocusRef = _this.props.initialFocusRef;

      if (initialFocusRef && initialFocusRef.current) {
        initialFocusRef.current.focus();
      }
    };

    return _this;
  }

  var _proto = ModalComponent.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        className = _this$props.className,
        forwardedRef = _this$props.forwardedRef,
        forwardedAs = _this$props.forwardedAs,
        theme = _this$props.theme,
        opened = _this$props.opened,
        onClose = _this$props.onClose,
        children = _this$props.children,
        persistent = _this$props.persistent,
        onClick = _this$props.onClick,
        onKeyDown = _this$props.onKeyDown,
        initialFocusRef = _this$props.initialFocusRef,
        props = _objectWithoutPropertiesLoose(_this$props, ["className", "forwardedRef", "forwardedAs", "theme", "opened", "onClose", "children", "persistent", "onClick", "onKeyDown", "initialFocusRef"]);

    return React.createElement(Transition, {
      timeout: theme ? theme.modalTransitionDuration : 300,
      in: opened
    }, function (status) {
      if (status === 'exited') return null;
      return React.createElement(Portal, null, React.createElement(FocusLock, {
        returnFocus: true,
        onActivation: _this2.onFocusLockActivation
      }, React.createElement("div", _extends({
        className: cx$$1('sui-modal', "sui-modal-transition-" + status, className),
        ref: _this2.handleDialogRef,
        onClick: wrapEvent(onClick, function (event) {
          event.stopPropagation();
          onClose();
        }),
        onKeyDown: wrapEvent(onKeyDown, function (event) {
          if (event.key === 'Escape') {
            event.stopPropagation();
            onClose();
          }
        })
      }, props), React.createElement(ModalContext.Provider, {
        value: {
          contentRef: _this2.contentRef,
          onClose: onClose
        }
      }, children))));
    });
  };

  return ModalComponent;
}(React.Component);

var ModalComponentWithTheme =
/*#__PURE__*/
withTheme$1(ModalComponent);
var Modal =
/*#__PURE__*/
createComponent(function () {
  return {
    name: 'modal',
    InnerComponent: ModalComponentWithTheme,
    style:
    /*#__PURE__*/
    css$1("position:fixed;top:0;right:0;bottom:0;left:0;z-index:", th('zIndexModal'), ";visibility:visible;overflow-x:hidden;overflow-y:auto;opacity:0;outline:0;background-color:", th('modalBackdropBg'), ";", mixin('transition',
    /*#__PURE__*/
    css$1("opacity ", th('modalTransitionDuration'), "ms ease-in-out")), ";&.sui-modal-transition-entering{opacity:0;}&.sui-modal-transition-entered{opacity:1;}&.sui-modal-transition-exiting{opacity:0;}"),
    propTypes: {
      children: PropTypes.node,
      opened: PropTypes.bool,
      onClose: PropTypes.func,
      initialFocusRef: PropTypes.object
    },
    defaultProps: {
      persistent: true
    }
  };
});

var ModalBody =
/*#__PURE__*/
createComponent(function () {
  return {
    name: 'modal-body',
    style:
    /*#__PURE__*/
    css$1("position:relative;flex:1 1 auto;padding:", th('modalInnerPadding'), ";"),
    propTypes: {
      children: PropTypes.node
    }
  };
});

var stopPropagation = function stopPropagation(event) {
  return event.stopPropagation();
};

var ModalContent =
/*#__PURE__*/
createComponent(function () {
  return {
    name: 'modal-content',
    render: function render(_ref) {
      var Component = _ref.Component,
          _ref2 = _ref.ref,
          onClick = _ref.onClick,
          props = _objectWithoutPropertiesLoose(_ref, ["Component", "ref", "onClick"]);

      return React.createElement(ModalContext.Consumer, null, function (modalContext) {
        return React.createElement(Component, _extends({
          tabIndex: "-1",
          ref: function ref(node) {
            if (modalContext) modalContext.contentRef.current = node;
            if (_ref2) _ref2(node);
          },
          onClick: wrapEvent(onClick, stopPropagation)
        }, props));
      });
    },
    style:
    /*#__PURE__*/
    css$1("position:relative;display:flex;flex-direction:column;width:100%;pointer-events:auto;background-color:", th('modalContentBg'), ";background-clip:padding-box;border:", th('modalContentBorderWidth'), " solid ", th('modalContentBorderColor'), ";border-radius:", th('modalContentBorderRadius'), ";box-shadow:", th('modalContentBoxShadowXs'), ";outline:0;", up('sm',
    /*#__PURE__*/
    css$1("box-shadow:", th('modalContentBoxShadowSmUp'), ";")), ";"),
    propTypes: {
      children: PropTypes.node
    }
  };
});

var ModalCloseButton =
/*#__PURE__*/
createComponent(function () {
  return {
    name: 'modal-close-button',
    defaultComponent: 'button',
    render: function render(_ref) {
      var Component = _ref.Component,
          onClick = _ref.onClick,
          ref = _ref.ref,
          props = _objectWithoutPropertiesLoose(_ref, ["Component", "onClick", "ref"]);

      return React.createElement(ModalContext.Consumer, null, function (modalContext) {
        return React.createElement(Component, _extends({
          ref: ref,
          onClick: wrapEvent(onClick, function () {
            if (modalContext) {
              modalContext.onClose();
            }
          })
        }, props), React.createElement("span", {
          "aria-hidden": "true"
        }, "\xD7"));
      });
    },
    style:
    /*#__PURE__*/
    css$1("position:absolute;cursor:pointer;top:0.2rem;right:0.2rem;padding:0.3rem 0.8rem;margin:0;background-color:transparent;appearance:none;border:0;font-size:1.5rem;font-weight:700;line-height:1;border-radius:", th('borderRadius'), ";opacity:0.5;", th('transitionBase'), ";&:focus{opacity:1;", mixin('controlFocus'), ";}&:hover{opacity:1;}"),
    propTypes: {
      children: PropTypes.node
    }
  };
});

var ModalDialog =
/*#__PURE__*/
createComponent(function () {
  return {
    name: 'modal-dialog',
    render: function render(_ref) {
      var Component = _ref.Component,
          props = _objectWithoutPropertiesLoose(_ref, ["Component"]);

      return React.createElement(Component, _extends({
        role: "dialog",
        "aria-modal": "true"
      }, props));
    },
    style:
    /*#__PURE__*/
    css$1("position:relative;width:auto;margin:", th('modalDialogMargin'), ";pointer-events:none;display:flex;align-items:center;min-height:calc( 100% - ", th('modalDialogMargin', function (value) {
      return calc(value, function (x) {
        return x * 2;
      });
    }), " );", up('sm',
    /*#__PURE__*/
    css$1("max-width:500px;margin:", th('modalDialogMarginYSmUp'), " auto;min-height:calc( 100% - ", th('modalDialogMarginYSmUp', function (value) {
      return calc(value, function (x) {
        return x * 2;
      });
    }), " );")), ";"),
    propTypes: {
      children: PropTypes.node
    }
  };
});

var ModalFooter =
/*#__PURE__*/
createComponent(function () {
  return {
    name: 'modal-footer',
    style:
    /*#__PURE__*/
    css$1("display:flex;align-items:center;justify-content:flex-end;padding:", th('modalInnerPadding'), ";border-top:", th('modalFooterBorderWidth'), " solid ", th('modalFooterBorderColor'), ";>:not(:first-child){margin-left:0.25rem;}>:not(:last-child){margin-right:0.25rem;}"),
    propTypes: {
      children: PropTypes.node
    }
  };
});

var ModalHeader =
/*#__PURE__*/
createComponent(function () {
  return {
    name: 'modal-header',
    style:
    /*#__PURE__*/
    css$1("display:flex;align-items:flex-start;justify-content:space-between;padding:", th('modalInnerPadding'), ";border-bottom:", th('modalHeaderBorderWidth'), " solid ", th('modalHeaderBorderColor'), ";border-top-left-radius:", th('modalContentBorderRadius'), ";border-top-right-radius:", th('modalContentBorderRadius'), ";"),
    propTypes: {
      children: PropTypes.node
    }
  };
});

var sizeStyle$3 = {
  sm:
  /*#__PURE__*/
  css$1(".sui-radio-content{width:0.875rem;height:0.875rem;}.sui-radio-circle{width:8px;height:8px;}"),
  md:
  /*#__PURE__*/
  css$1(".sui-radio-content{width:1rem;height:1rem;}.sui-radio-circle{width:10px;height:10px;}"),
  lg:
  /*#__PURE__*/
  css$1(".sui-radio-content{width:1.25rem;height:1.25rem;}.sui-radio-circle{width:14px;height:14px;}")
};
var containerSystem$1 =
/*#__PURE__*/
composeStyles$1(basics, dimensions, space, flexboxes, positions);
var contentSystem$1 =
/*#__PURE__*/
composeStyles$1(dimensions, backgrounds, borders);
var ModalHeader$1 =
/*#__PURE__*/
createComponent(function () {
  return {
    name: 'radio',
    system: composeStyles$1(containerSystem$1, contentSystem$1),
    applySystem: null,
    render: function render(_ref) {
      var Component = _ref.Component,
          ref = _ref.ref,
          className = _ref.className,
          size = _ref.size,
          props = _objectWithoutPropertiesLoose(_ref, ["Component", "ref", "className", "size"]);

      return React.createElement(SwitchState, props, function (_ref2) {
        var input = _ref2.input;
        return React.createElement(Component, {
          className: className
        }, React.createElement("input", _extends({
          ref: ref,
          type: "radio"
        }, input)), React.createElement("div", {
          className: "sui-radio-content"
        }, React.createElement("div", {
          className: "sui-radio-circle"
        })));
      });
    },
    style:
    /*#__PURE__*/
    css$1("display:inline-flex;align-items:center;justify-content:center;position:relative;width:1.5rem;height:1.5rem;position:relative;.sui-radio-content{display:flex;flex-shrink:0;align-items:center;justify-content:center;border-radius:50%;background-color:", th('inputBgColor'), ";border-width:", th('inputBorderWidth'), ";border-style:solid;border-color:", th('inputBorderColor'), ";", th('transitionBase'), ";}input:checked + .sui-radio-content{border-color:", th('primary'), ";.sui-radio-circle{transform:scale(1);}}input:focused + .sui-radio-content{", mixin('controlFocus'), ";}input:disabled + .sui-radio-content{background-color:", th('inputDisabledBgColor'), ";}.sui-radio-circle{", th('transitionBase'), ";border-radius:50%;background-color:", th('primary'), ";transform:scale(0);}", function (p) {
      return p.size && sizeStyle$3[p.size];
    }, ";", containerSystem$1, ";.sui-radio-content{", contentSystem$1, ";}"),
    propTypes: {
      checked: PropTypes.bool,
      disabled: PropTypes.bool,
      onChange: PropTypes.func,
      size: PropTypes.oneOf(['sm', 'md', 'lg']),
      value: PropTypes.string
    },
    defaultProps: {
      size: 'md'
    }
  };
});

var RadioGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(RadioGroup, _React$Component);

  function RadioGroup() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.controls = [];
    return _this;
  }

  var _proto = RadioGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      suiGroup: this
    };
  };

  _proto.register = function register(control) {
    this.controls.push(control);
  };

  _proto.unregister = function unregister(control) {
    var index = this.controls.indexOf(control);
    if (index !== -1) this.controls.splice(index, 1);
  };

  _proto.notify = function notify(event) {
    this.controls.forEach(function (control) {
      if (control.props.checked === undefined && control.props.name === event.target.name && control.props.value !== event.target.value) {
        control.updateState({
          checked: false
        });
      }
    });
  };

  _proto.render = function render() {
    return this.props.children;
  };

  return RadioGroup;
}(React.Component);

RadioGroup.childContextTypes = {
  suiGroup: PropTypes.object
};
RadioGroup.propTypes = {
  children: PropTypes.node
};

var Row =
/*#__PURE__*/
createComponent(function () {
  return {
    name: 'row',
    injectTheme: true,
    render: function render(_ref) {
      var Component = _ref.Component,
          gutter = _ref.gutter,
          className = _ref.className,
          justifyContent = _ref.justifyContent,
          theme = _ref.theme,
          props = _objectWithoutPropertiesLoose(_ref, ["Component", "gutter", "className", "justifyContent", "theme"]);

      return React.createElement(Component, _extends({
        className: className
      }, props));
    },
    style: function style$$1(p) {
      var gutter = px(prop('gutter', 'gridGutter')(p));
      return (
        /*#__PURE__*/
        css$1("flex-grow:1;flex-wrap:wrap;display:flex;margin-left:-", gutter, ";margin-right:-", gutter, ";")
      );
    },
    propTypes: {
      children: PropTypes.node,
      gutter: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    }
  };
});

var renderOption = function renderOption(option) {
  var _ref = typeof option === 'string' ? {
    label: option,
    value: option
  } : option,
      label = _ref.label,
      value = _ref.value;

  return React.createElement("option", {
    key: value,
    value: value
  }, label);
};

var sizeStyle$4 = {
  sm:
  /*#__PURE__*/
  css$1("select{padding:",
  /*#__PURE__*/
  th('inputPaddingYSm'), " ",
  /*#__PURE__*/
  th('inputPaddingXSm'), ";font-size:",
  /*#__PURE__*/
  th('fontSizeSm'), ";border-radius:",
  /*#__PURE__*/
  th('borderRadiusSm'), ";", function (p) {
    return p.arrow && !p.multiple && 'padding-right: 1.225rem;';
  }, ";}.sui-select-arrow{right:0.35rem;width:0.525rem;}"),
  md:
  /*#__PURE__*/
  css$1("select{padding:",
  /*#__PURE__*/
  th('inputPaddingY'), " ",
  /*#__PURE__*/
  th('inputPaddingX'), ";font-size:",
  /*#__PURE__*/
  th('fontSizeBase'), ";", function (p) {
    return p.arrow && !p.multiple && 'padding-right: 1.6rem;';
  }, ";border-radius:",
  /*#__PURE__*/
  th('borderRadius'), ";}.sui-select-arrow{right:0.5rem;width:0.6rem;}"),
  lg:
  /*#__PURE__*/
  css$1("select{padding:",
  /*#__PURE__*/
  th('inputPaddingYLg'), " ",
  /*#__PURE__*/
  th('inputPaddingXLg'), ";font-size:",
  /*#__PURE__*/
  th('fontSizeLg'), ";border-radius:",
  /*#__PURE__*/
  th('borderRadiusLg'), ";", function (p) {
    return p.arrow && !p.multiple && 'padding-right: 2rem;';
  }, ";}.sui-select-arrow{right:0.625rem;width:0.75rem;}")
};
var validStyle$1 =
/*#__PURE__*/
css$1("select{border-color:",
/*#__PURE__*/
th('success'), ";&:focus{border-color:",
/*#__PURE__*/
th('success'), ";box-shadow:",
/*#__PURE__*/
mixin('controlFocusBoxShadow', 'success'), ";}}");
var invalidStyle$1 =
/*#__PURE__*/
css$1("select{border-color:",
/*#__PURE__*/
th('danger'), ";&:focus{border-color:",
/*#__PURE__*/
th('danger'), ";box-shadow:",
/*#__PURE__*/
mixin('controlFocusBoxShadow', 'danger'), ";}}");
var controlStyle$1 =
/*#__PURE__*/
css$1("display:block;width:100%;select{display:block;width:100%;&:focus{border-color:",
/*#__PURE__*/
th('controlFocusBorderColor'), ";box-shadow:",
/*#__PURE__*/
mixin('controlFocusBoxShadow', 'primary'), ";}}", function (p) {
  switch (p.valid) {
    case true:
      return validStyle$1;

    case false:
      return invalidStyle$1;

    default:
      return null;
  }
}, ";");
var Select =
/*#__PURE__*/
createComponent(function () {
  return {
    name: 'select',
    render: function render(_ref2) {
      var Component = _ref2.Component,
          arrow = _ref2.arrow,
          control = _ref2.control,
          className = _ref2.className,
          options = _ref2.options,
          size = _ref2.size,
          valid = _ref2.valid,
          children = _ref2.children,
          props = _objectWithoutPropertiesLoose(_ref2, ["Component", "arrow", "control", "className", "options", "size", "valid", "children"]);

      if (options) {
        // eslint-disable-next-line no-console
        console.warn('Smooth UI: `options` prop of "Select" is deprecated and will be removed in v7, use <option> instead.');
      }

      return React.createElement(Component, {
        className: className
      }, arrow && !props.multiple ? React.createElement("svg", {
        className: "sui-select-arrow",
        viewBox: "0 0 10 5"
      }, React.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, React.createElement("path", {
        d: "M17 14H-7v-24h24"
      }), React.createElement("path", {
        fill: "currentColor",
        opacity: 0.5,
        d: "M0 0l5 5 5-5"
      }))) : null, React.createElement("select", props, children || options.map(function (node) {
        return node.options ? React.createElement("optgroup", {
          key: node.label,
          label: node.label
        }, node.options.map(renderOption)) : renderOption(node);
      })));
    },
    style:
    /*#__PURE__*/
    css$1("display:inline-block;position:relative;select{appearance:none;-webkit-appearance:none;-moz-appearance:none;-webkit-border-radius:0;display:inline-block;border-width:", th('inputBorderWidth'), ";border-color:", th('inputBorderColor'), ";border-style:solid;line-height:", th('lineHeightBase'), ";", th('transitionBase'), ";color:", th('inputTextColor'), ";&:focus{", mixin('controlFocus'), ";}&:disabled{background-color:", th('inputDisabledBgColor'), ";color:", th('inputDisabledText'), ";}}.sui-select-arrow{position:absolute;top:50%;pointer-events:none;}", function (p) {
      return p.size && sizeStyle$4[p.size];
    }, ";", function (p) {
      return p.control && controlStyle$1;
    }, ";"),
    propTypes: {
      arrow: PropTypes.bool,
      control: PropTypes.bool,
      options: PropTypes.array,
      size: PropTypes.oneOf(['sm', 'md', 'lg']),
      valid: PropTypes.bool,
      children: PropTypes.node
    },
    defaultProps: {
      arrow: true,
      size: 'md'
    }
  };
});

var Switch =
/*#__PURE__*/
createComponent(function () {
  return {
    name: 'switch',
    system: system,
    applySystem: null,
    render: function render(_ref) {
      var Component = _ref.Component,
          ref = _ref.ref,
          className = _ref.className,
          _ref$onLabel = _ref.onLabel,
          onLabel = _ref$onLabel === void 0 ? 'ON' : _ref$onLabel,
          _ref$offLabel = _ref.offLabel,
          offLabel = _ref$offLabel === void 0 ? 'OFF' : _ref$offLabel,
          labeled = _ref.labeled,
          props = _objectWithoutPropertiesLoose(_ref, ["Component", "ref", "className", "onLabel", "offLabel", "labeled"]);

      return React.createElement(SwitchState, props, function (_ref2) {
        var input = _ref2.input;
        return React.createElement(Component, {
          className: className
        }, React.createElement("input", _extends({
          ref: ref,
          type: "checkbox"
        }, input)), React.createElement("div", {
          className: "sui-switch-wrapper"
        }, React.createElement("div", {
          className: "sui-switch-content"
        }, React.createElement("span", {
          className: "sui-switch-label sui-switch-label-on"
        }, labeled ? onLabel : ''), React.createElement("div", {
          className: "sui-switch-ball"
        }), React.createElement("span", {
          className: "sui-switch-label sui-switch-label-off"
        }, labeled ? offLabel : ''))));
      });
    },
    style:
    /*#__PURE__*/
    css$1("display:inline-block;position:relative;width:50px;height:24px;.sui-switch-wrapper{width:50px;height:24px;border-radius:34px;background-color:", th('gray300'), ";overflow:hidden;cursor:pointer;border-width:", th('inputBorderWidth'), ";border-color:", th('inputBorderColor'), ";border-style:solid;", th('transitionBase'), ";font-size:9px;font-weight:800;}input:focused + .sui-switch-wrapper{", mixin('controlFocus'), ";}input:checked + .sui-switch-wrapper{background-color:", th('primaryLight'), ";border-color:transparent;.sui-switch-content{transform:translateX(0);}.sui-switch-ball{background-color:", th('primary'), ";}}input:disabled + .sui-switch-wrapper{opacity:0.5;}.sui-switch-ball{flex-shrink:0;background-color:", th('gray500'), ";border-radius:50%;width:18px;height:18px;", th('transitionBase'), ";}.sui-switch-content{display:flex;align-items:center;height:22px;", th('transitionBase'), ";transform:translateX(-25px);}.sui-switch-label{flex-shrink:0;width:27px;text-align:center;user-select:none;&.sui-switch-label-on{color:", th('primary'), ";}&.sui-switch-label-off{color:", th('gray900'), ";}}.sui-switch-wrapper{", system, ";}"),
    propTypes: {
      checked: PropTypes.bool,
      disabled: PropTypes.bool,
      labeled: PropTypes.bool,
      onLabel: PropTypes.string,
      offLabel: PropTypes.string,
      onChange: PropTypes.func
    }
  };
});

var Textarea =
/*#__PURE__*/
Input.withComponent('textarea', {
  target: "e1qfj6rk0"
});

var Toggler =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Toggler, _React$Component);

  function Toggler() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      toggled: _this.props.defaultToggled
    };

    _this.onToggle = function (value) {
      _this.setState(function (previousState) {
        return {
          toggled: typeof value === 'boolean' ? value : !previousState.toggled
        };
      }, function () {
        if (_this.props.onToggle) {
          _this.props.onToggle(_this.state.toggled);
        }
      });
    };

    return _this;
  }

  var _proto = Toggler.prototype;

  _proto.render = function render() {
    return this.props.children({
      toggled: this.state.toggled,
      onToggle: this.onToggle
    });
  };

  return Toggler;
}(React.Component);

Toggler.propTypes = {
  children: PropTypes.func.isRequired,
  defaultToggled: PropTypes.bool,
  onToggle: PropTypes.func
};
Toggler.defaultProps = {
  defaultToggled: false
};

var variantTags = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  'display-1': 'h1',
  'display-2': 'h2',
  'display-3': 'h3',
  'display-4': 'h4'
};
var commonHeadingStyle =
/*#__PURE__*/
css$1("margin-top:0;margin-bottom:",
/*#__PURE__*/
th('headingsMarginBottom'), ";font-weight:",
/*#__PURE__*/
th('headingsFontWeight'), ";line-height:",
/*#__PURE__*/
th('headingsLineHeight'), ";color:",
/*#__PURE__*/
th('headingsColor'), ";",
/*#__PURE__*/
th('headingsFontFamily', function (font) {
  return font ? "font-family: " + font + ";" : null;
}), ";");
var variantStyle = {
  h1:
  /*#__PURE__*/
  css$1(commonHeadingStyle, ";font-size:",
  /*#__PURE__*/
  th('h1FontSize'), ";"),
  h2:
  /*#__PURE__*/
  css$1(commonHeadingStyle, ";font-size:",
  /*#__PURE__*/
  th('h2FontSize'), ";"),
  h3:
  /*#__PURE__*/
  css$1(commonHeadingStyle, ";font-size:",
  /*#__PURE__*/
  th('h3FontSize'), ";"),
  h4:
  /*#__PURE__*/
  css$1(commonHeadingStyle, ";font-size:",
  /*#__PURE__*/
  th('h4FontSize'), ";"),
  h5:
  /*#__PURE__*/
  css$1(commonHeadingStyle, ";font-size:",
  /*#__PURE__*/
  th('h5FontSize'), ";"),
  h6:
  /*#__PURE__*/
  css$1(commonHeadingStyle, ";font-size:",
  /*#__PURE__*/
  th('h6FontSize'), ";"),
  'display-1':
  /*#__PURE__*/
  css$1(commonHeadingStyle, ";font-size:",
  /*#__PURE__*/
  th('display1Size'), ";font-weight:",
  /*#__PURE__*/
  th('display1Weight'), ";line-height:",
  /*#__PURE__*/
  th('displayLineHeight'), ";"),
  'display-2':
  /*#__PURE__*/
  css$1(commonHeadingStyle, ";font-size:",
  /*#__PURE__*/
  th('display2Size'), ";font-weight:",
  /*#__PURE__*/
  th('display2Weight'), ";line-height:",
  /*#__PURE__*/
  th('displayLineHeight'), ";"),
  'display-3':
  /*#__PURE__*/
  css$1(commonHeadingStyle, ";font-size:",
  /*#__PURE__*/
  th('display3Size'), ";font-weight:",
  /*#__PURE__*/
  th('display3Weight'), ";line-height:",
  /*#__PURE__*/
  th('displayLineHeight'), ";"),
  'display-4':
  /*#__PURE__*/
  css$1(commonHeadingStyle, ";font-size:",
  /*#__PURE__*/
  th('display4Size'), ";font-weight:",
  /*#__PURE__*/
  th('display4Weight'), ";line-height:",
  /*#__PURE__*/
  th('displayLineHeight'), ";")
};
var Typography =
/*#__PURE__*/
createComponent(function () {
  return {
    name: 'typo',
    defaultComponent: null,
    render: function render(_ref) {
      var className = _ref.className,
          BaseComponent = _ref.Component,
          variant = _ref.variant,
          props = _objectWithoutPropertiesLoose(_ref, ["className", "Component", "variant"]);

      var Component = BaseComponent || variantTags[variant] || 'span';
      return React.createElement(Component, _extends({
        className: className
      }, props));
    },
    style:
    /*#__PURE__*/
    css$1(function (p) {
      return p.variant && variantStyle[p.variant];
    }, ";"),
    propTypes: {
      children: PropTypes.node,
      variant: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'display-1', 'display-2', 'display-3', 'display-4'])
    }
  };
});

var globalStyle = function globalStyle(customTheme) {
  if (customTheme === void 0) {
    customTheme = theme;
  }

  return [].concat(normalize(), ["\n    html,\n    body {\n      font-family: " + th('fontFamily')({
    theme: customTheme
  }) + ";\n      font-size: " + th('fontSizeBase')({
    theme: customTheme
  }) + ";\n      line-height: " + th('lineHeightBase')({
    theme: customTheme
  }) + ";\n    }\n\n    * {\n      box-sizing: border-box;\n    }\n  "]);
};

export { theme, styles, Alert, Box, Breakpoint, Button, Checkbox, Col, ControlFeedback, FormCheck, FormCheckLabel, FormGroup, Grid, Input, Label, Modal, ModalBody, ModalContent, ModalContext, ModalCloseButton, ModalDialog, ModalFooter, ModalHeader, Portal, ModalHeader$1 as Radio, RadioGroup, Row, Select, Switch, SwitchState, Textarea, Toggler, Typography, styled, globalStyle, DEFAULT_BREAKPOINTS, getBreakpoints, getBreakpointsEntries, getNextBreakpoint, getPreviousBreakpoint, getBreakpointMin, getBreakpointMax, mediaMinWidth, mediaMaxWidth, mediaBetweenWidth, up, down, between, opacity, overflow, basics, fontFamily$1 as fontFamily, fontSize, lineHeight, fontWeight, textAlign, letterSpacing, color, typography, width, height, maxWidth, maxHeight, minWidth, minHeight, dimensions, space, display, alignItems, alignContent, justifyContent, flexWrap, flexBasis, flexDirection, flex, justifySelf, alignSelf, order, flexboxes, background, backgroundColor, backgroundImage, backgroundSize, backgroundPosition, backgroundRepeat, backgrounds, position, zIndex, top, right, bottom, left, positions, border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderRadius$1 as borderRadius, boxShadow, borders, system, lazyTh, th, mixin, prop, calc, unit, px, stylePropType, style, composeStyles, withTheme$1 as withTheme, css$1 as css };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@smooth-ui/core-em/dist/smooth-ui-core-em.es.js
// module id = 32
// module chunks = 0